import axios from "axios";

export const uploadFile = async (props) => {
    const url = process.env.REACT_APP_BASE_URL + "/api/upload/file";

    let result = [];
    // console.log(props);
    const formData = new FormData();
    formData.append("body", props.file.file);

    const config = {
        headers: {
            "content-type": "multipart/form-data",
            "fileName": props.fileName,
        },
    };

    await axios.post(url, formData, config)
    .then((response) => {
        const data = response.data;
        result = { ...data };
        if (data.exito === 1) {
            console.log("archivo subido...");
        }
    });

    return result;
};
